import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type VisbilitySettingsFragment = { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null };


export type VisbilitySettingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const VisbilitySettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment VisbilitySettings on VisibilitySettingsType {
  groupIds
  accessType
  restrictionConfigs {
    type
    entityIds
    contextualUserId
  }
}
    `;